import { PublicShell } from "@/components/site/PublicShell";
import { TransparencyEvidence } from "@/components/site/TransparencyEvidence";

export default function Transparency() {
  return (
    <PublicShell wide title="Transparency: the honest track record" subtitle="Factual, verifiable performance evidence for EV-IDEX predictions — backtested, paper-traded and live results kept strictly apart, every number with its sample size and uncertainty, losses included. This page is updated automatically and shows no customer data.">
      <TransparencyEvidence />
    </PublicShell>
  );
}
